import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from '../types'

export const getAsinUsageSummary = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post('/api/asin_usage_facts/summary/banner/', params, {
        headers: getCerebroHeaders(options.headers),
    })
addCache(getAsinUsageSummary)

export const getAsinUsageSummaryExport = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/asin_usage_facts/summary/banner/export/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
